import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';
import { paintCodeOptions, colourOptions } from 'constants/finishing';

const External = ({ control, tableView }) => {
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>External Finish</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.externalCoatingQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.externalCoatingType'
                control={control}
                label='Type'
                creatable={true}
                options={paintCodeOptions}
                style={{width: '39%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.externalCoatingColour'
                control={control}
                label='Colour'
                creatable={true}
                options={colourOptions}
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.externalCoatingReport'
                type='text'
                control={control}
                label='Ext Report'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.externalCoatingITP'
                type='text'
                control={control}
                label='Ext ITP'
                style={{width: '19%', marginRight: '1%'}}
            />
        </>   
    );
};

export default External;
